var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrammar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1836_15487)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1836_15487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1836_15487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72736 13.6667H11.7624L6.78676 1H4.97566L0 13.6667H2.03505L3.12561 10.7436H8.61733L9.72736 13.6667ZM3.86563 8.79487L5.88121 3.41641L7.89679 8.79487H3.86563ZM18.6271 9.36974L10.7498 17.2523L7.17624 13.6667L5.80331 15.0405L10.7595 20L20 10.7436L18.6271 9.36974Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1836_15487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrammar);
export default __webpack_public_path__ + "static/media/grammar.550fd5c1b41b9f2e64fa182e8ba88356.svg";
export { ForwardRef as ReactComponent };